/**
 * allows to convert business filters into light business filter
 */

import {
  BusinessFilter,
  BusinessFilterNature,
  extractValueWithSynonyms,
  KpkFilterType,
  LightBusinessFilter,
  LightKpkFilterValue,
} from "@keepeek/commons";

export function convertToLightBusinessFilter(
  businessFilters: BusinessFilter[],
): LightBusinessFilter[] {
  return businessFilters.map((bf) => {
    let values: LightKpkFilterValue[];
    switch (bf.nature) {
      case BusinessFilterNature.FACET_MULTI:
      case BusinessFilterNature.FACET:
        // for FACET nature, only the selected facet is kept in values
        values = bf.filter.values
          .filter((v) => v.selected)
          .map((v) => {
            let valueToRebounce = v.id;
            if (v.mediaSearchLink && bf.filter.id && bf.filter.type === KpkFilterType.RadioFacet) {
              // Get label and synonym in mediaSearch link fq parameter
              const valueWithSynonyms = extractValueWithSynonyms(v.mediaSearchLink, bf.filter.id);
              if (valueWithSynonyms) {
                valueToRebounce = valueWithSynonyms;
              }
            }
            if (v.path) {
              valueToRebounce = v.path;
            }
            return {
              i: bf.nature === BusinessFilterNature.FACET ? valueToRebounce : v.id,
              l: v.label,
              t: v.title,
              s: v.selected,
              aq: v.addQuotes,
            };
          });
        break;
      default:
        // for OTHER nature type, we keep ALL the values
        values = bf.filter.values.map((v) => {
          return {
            i: v.id,
            l: v.label,
            t: v.title,
            s: v.selected,
            aq: v.addQuotes,
          };
        });
    }
    return {
      n: bf.nature,
      f: {
        i:
          bf.nature === BusinessFilterNature.FACET_MULTI
            ? bf.filter.id.split(".")[0]
            : bf.filter.id,
        l:
          bf.nature === BusinessFilterNature.FACET || bf.nature === BusinessFilterNature.FACET_MULTI
            ? bf.filter.label
            : undefined,
        t: bf.filter.type,
        m: bf.filter.modifiers?.find((m) => m.selected)?.type || undefined,
        s: bf.filter.showSub,
        v: values,
        f: bf.filter.internalName,
        nfr: bf.filter.notFoundReference,
      },
      h: bf.hide,
    };
  });
}
